import api from "../api/apiClient";
import { toast } from "react-toastify";

const graphService = {
  retrieveSearchAndGraphData: async (searchId, userId) => {
    try {
      const response = await api.get(`/retrieve_search/${searchId}/${userId}/`);
      if (response.status !== 200) {
        throw new Error("Failed to retrieve search");
      }
      return response.data;
    } catch (error) {
      console.error("Error in retrieveSearchAndGraphData:", error);
      throw error;
    }
  },
  // In graphService.js
  fetchAllChildData: async (userId, nodeid) => {
    const response = await api.post(`/graph/allchild/${userId}/`, {
      nodeid,
    });
    return response.data;
  },

  graphSearch: async (userId, criteria) => {
    try {
      const response = await api.post(`/graph/search/${userId}/`, criteria);
      if (response.status !== 200) {
        throw new Error("Failed to fetch graph data");
      }
      if (response.data.nodes && response.data.nodes.length === 0) {
        // Show toast message if nodes array is empty
        toast.error("No results found");
      }
      return response.data;
    } catch (error) {
      console.error("Error in graphSearch:", error);
      throw error;
    }
  },

  fetchGraphData: async (userId, selectedClasses, includeKeywords) => {
    try {
      const response = await api.post(
        `/graph/search/${userId}/`,
        {
          includeClasses: selectedClasses,
          includeTopics: [],
          includeKeywords: Array.from(includeKeywords || []),
          includeManualAndExpand: [],
          includeIds: [],
        },
        {
          headers: {
            Authorization: `Token ${localStorage.getItem("authToken")}`,
          },
        }
      );
      if (response.status !== 200) {
        throw new Error("Failed to fetch graph data");
      }
      if (response.data.nodes.length === 0) {
        // Show toast message if nodes array is empty
        toast.error("No results found");
      }
      return response.data;
    } catch (error) {
      console.error("Error in fetchGraphData:", error);
      throw error;
    }
  },

  fetchGraphDataByTags: async (userId, payload) => {
    try {
      const response = await api.post(`/graph/search/${userId}/`, payload);
      if (response.status !== 200) {
        throw new Error("Network response was not ok");
      }
      const data = response.data;
      if (data.nodes.length === 0) {
        // Show toast message if nodes array is empty
        toast.error("No results found");
      }

      return data;
    } catch (error) {
      console.error("Error in fetchGraphDataByTags:", error);
      throw error;
    }
  },

  handleSearchSelect: async (searchId, userId) => {
    try {
      const criteria = await graphService.retrieveSearchAndGraphData(
        searchId,
        userId
      );
      const rules = JSON.parse(criteria);
      const rulesforJsonData = {
        includeClasses: rules.includeClasses ?? [],
        includeTopics: [],
        includeKeywords: rules.includeKeywords ?? [],
        includeManualAndExpand: [],
        includeIds: [],
      };
      return await graphService.graphSearch(userId, rulesforJsonData);
    } catch (error) {
      console.error("Error in handleSearchSelect:", error);
      throw error;
    }
  },
};

export default graphService;
